/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

define(function (require, exports, module) {
  'use strict';

  module.exports = {
    BACKSPACE: 8,
    DOWN_ARROW: 40,
    ENTER: 13,
    ESCAPE: 27,
    LEFT_ARROW: 37,
    NUMPAD_0: 96,
    NUMPAD_9: 105,
    NUM_0: 48,
    NUM_1: 49,
    NUM_9: 57,
    PERIOD: 190,
    RIGHT_ARROW: 39,
    TAB: 9,
    UP_ARROW: 38
  };
});



// WEBPACK FOOTER //
// ./lib/key-codes.js